module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-taiguo.70a1a3f4.jpeg";